import { Link, useNavigate } from 'react-router-dom';
import { useMe } from '../../api/hooks';
import { useJobs } from '../../api/jobs';

const STATUS_CLASS: Record<string, string> = {
  DRAFT: 'badge',
  OPEN: 'badge badge-open',
  CLOSED: 'badge badge-closed',
};

export default function JobsList() {
  const navigate = useNavigate();
  const { data: me } = useMe();
  const { data: jobs, isLoading, error } = useJobs();
  const canCreate = me?.roles.isHr || me?.roles.isAdmin;

  return (
    <div className="panel">
      <div className="panel-head">
        <h2>Job descriptions</h2>
        {canCreate && (
          <button className="btn-primary" onClick={() => navigate('/jobs/new')}>
            New job
          </button>
        )}
      </div>

      {isLoading && <p className="muted">Loading jobs…</p>}
      {error && <p className="error">Could not load jobs: {String(error)}</p>}

      {jobs && jobs.length === 0 && (
        <p className="muted">No job descriptions visible to you yet.</p>
      )}

      {jobs && jobs.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Status</th>
              <th>Department</th>
              <th>Location</th>
              <th className="center">Candidates</th>
              <th className="center">Threshold</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((j) => (
              <tr key={j.id} className="row-link" onClick={() => navigate(`/jobs/${j.id}`)}>
                <td>
                  <Link to={`/jobs/${j.id}`} onClick={(e) => e.stopPropagation()}>
                    {j.title}
                  </Link>
                </td>
                <td>
                  <span className={STATUS_CLASS[j.status]}>{j.status}</span>
                </td>
                <td>{j.department ?? '—'}</td>
                <td>{j.location ?? '—'}</td>
                <td className="center">{j.candidateCount}</td>
                <td className="center">{Math.round(j.reviewThreshold * 100)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
